import { useQuery } from '@tanstack/react-query';
import { MINUTE_IN_MS } from '@/modules/shared/constants/time';
import { CountryModel } from '@/modules/shared/types/country';
import { getCountries } from './getCountries';
import { COMPANY_API_COUNTRY_MOCKED } from '@/env';
import { mockedCountries } from './mock';
import { QUERY_KEY_CONFIG_COUNTRIES } from '../../constants';

type Props = {
  companyId: string
}

/**
 * Fetches available countries.
 */
export function useQueryCountries(props: Props) {
  const { companyId } = props
  return useQuery<CountryModel[]>({
    queryKey: [QUERY_KEY_CONFIG_COUNTRIES, companyId],
    queryFn: async () => {
        if(COMPANY_API_COUNTRY_MOCKED){
            return mockedCountries
        }
      // @TODO remove companyId from queryKey and endpoint when backend is fixed
      const { data } = await getCountries(props);
      return data;
    },
    staleTime: MINUTE_IN_MS * 60, // cache for 60 minutes
  });
}
